import { MarkerType } from '@xyflow/react'

export const nodes = [
  {
    id: '1',
    type: 'Polygon',
    data: {
      label: 'Diamond',
      points: [
        { x: 50, y: 20 },
        { x: 100, y: 50 },
        { x: 50, y: 80 },
        { x: 0, y: 50 }
      ],
    },
    position: { x: 250, y: 0 },
  },
  {
    id: '2',
    type: 'Polygon',
    data: {
      label: 'Triangle',
      points: [
        { x: 50, y: 20 },
        { x: 90, y: 80 },
        { x: 10, y: 80 },
      ],
    },
    position: { x: 450, y: 0 },
  },
  {
    id: '3',
    type: 'Polygon',
    data: {
      label: 'Pentagon',
      points: [
        { x: 50, y: 10 },
        { x: 90, y: 40 },
        { x: 75, y: 90 },
        { x: 25, y: 90 },
        { x: 10, y: 40 },
      ],
    },
    position: { x: 650, y: 0 },
  },
  {
    id: '4',
    type: 'Polygon',
    data: {
      label: 'Hexagon',
      points: [
        { x: 50, y: 10 },
        { x: 90, y: 30 },
        { x: 90, y: 70 },
        { x: 50, y: 90 },
        { x: 10, y: 70 },
        { x: 10, y: 30 },
      ],
    },
    position: { x: 850, y: 0 },
  },
  {
    id: '5',
    type: 'Polygon',
    data: {
      label: 'Star',
      points: [
        { x: 50, y: 10 },
        { x: 60, y: 35 },
        { x: 85, y: 35 },
        { x: 65, y: 50 },
        { x: 75, y: 75 },
        { x: 50, y: 60 },
        { x: 25, y: 75 },
        { x: 35, y: 50 },
        { x: 15, y: 35 },
        { x: 40, y: 35 },
      ],
    },
    position: { x: 1050, y: 0 },
  },
]

export const edges = []
